import React from 'react';
import { Redirect } from 'react-router-dom';

// AuthCallback is the target of the AAD redirect_uri. It only runs on a full
// interactive sign-in redirect. LastLoginDate is stamped server-side inside
// the statUser query resolver, so this component just redirects the user
// back to the page they originally tried to visit.
const AuthCallback: React.FunctionComponent = () => {
  const redirectUrl = window.sessionStorage.getItem('return-url') || '/';
  window.sessionStorage.removeItem('return-url');
  return <Redirect to={redirectUrl} />;
};

export default AuthCallback;
